import { render } from "./confirmBoxs.vue?vue&type=template&id=63860e33&scoped=true"
import script from "./confirmBoxs.vue?vue&type=script&lang=js"
export * from "./confirmBoxs.vue?vue&type=script&lang=js"

import "./confirmBoxs.vue?vue&type=style&index=0&id=63860e33&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63860e33"]])

export default __exports__